import React from 'react';
import clsx from 'clsx';

const SystemFlagWrapper = ({
  children,
  className,
  flush,
  solid,
}) => (
  <span className={clsx(
    'aridhia-system-flag',
    className,
    flush ? 'ml-0' : 'ml-10',
    solid && 'solid',
  )}
  >
    {children}
  </span>
);

export default SystemFlagWrapper;
